import { render, staticRenderFns } from "./PlacementsSingleDownloadPdp.vue?vue&type=template&id=083d18d0&"
import script from "./PlacementsSingleDownloadPdp.vue?vue&type=script&lang=js&"
export * from "./PlacementsSingleDownloadPdp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports